export const socketName = {
  c2c: 'c2c', // c2c聊天websocket名称
  exchange: 'exchange', // 币币交易websocket名称
};
// 默认的语言代码，此变量与默认语言没有任何关系，仅仅在未获取到当前语言时使用
export const defaultLangCode = 'zh_CN';
